module.exports = __webpack_public_path__ + "img/protecaoEficazAzul.a048a8c4.svg";